module.exports = __webpack_public_path__ + "img/horizontal_6_4_7042.49b27bac.png";